"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var LocaleWrapper_1 = require("../LocaleWrapper/LocaleWrapper");
var NameField_1 = __importDefault(require("../NameField/NameField"));
var ScaleDenominator_1 = __importDefault(require("../ScaleDenominator/ScaleDenominator"));
var FieldSet_1 = __importDefault(require("../FieldSet/FieldSet"));
var FilterTree_1 = __importDefault(require("../Filter/FilterTree/FilterTree"));
var Renderer_1 = __importDefault(require("../Symbolizer/Renderer/Renderer"));
var SymbolizerEditorWindow_1 = __importDefault(require("../Symbolizer/SymbolizerEditorWindow/SymbolizerEditorWindow"));
var _cloneDeep = require('lodash/cloneDeep');
var _isEqual = require('lodash/isEqual');
require("./Rule.css");
var en_US_1 = __importDefault(require("../../locale/en_US"));
var SLDRenderer_1 = require("../Symbolizer/SLDRenderer/SLDRenderer");
/**
 * UI container representing a Rule
 */
var Rule = /** @class */ (function (_super) {
    __extends(Rule, _super);
    function Rule(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Handles changing rule name
         */
        _this.onNameChange = function (name) {
            var rule = _cloneDeep(_this.state.rule);
            rule.name = name;
            if (_this.props.onRuleChange) {
                _this.props.onRuleChange(rule, _this.state.rule);
            }
            _this.setState({ rule: rule });
        };
        /**
         * Handles changing rule name
         */
        _this.onScaleDenominatorChange = function (scaleDenominator) {
            var rule = _cloneDeep(_this.state.rule);
            rule.scaleDenominator = scaleDenominator;
            if (_this.props.onRuleChange) {
                _this.props.onRuleChange(rule, _this.state.rule);
            }
            _this.setState({ rule: rule });
        };
        /**
         * Handles changing rule filter
         */
        _this.onFilterChange = function (filter) {
            var rule = _cloneDeep(_this.state.rule);
            rule.filter = filter;
            if (_this.props.onRuleChange) {
                _this.props.onRuleChange(rule, _this.state.rule);
            }
            _this.setState({ rule: rule });
        };
        /**
         * Handles changing rule symbolizer
         */
        _this.onSymbolizersChange = function (symbolizers) {
            var rule = _cloneDeep(_this.state.rule);
            rule.symbolizers = symbolizers;
            if (_this.props.onRuleChange) {
                _this.props.onRuleChange(rule, _this.state.rule);
            }
            _this.setState({ rule: rule });
        };
        _this.onScaleCheckChange = function (e) {
            var checked = e.target.checked;
            var rule = _cloneDeep(_this.state.rule);
            if (checked) {
                rule.scaleDenominator = _this.state.storedScaleDenominator;
            }
            else {
                _this.setState({
                    storedScaleDenominator: rule.scaleDenominator
                });
                rule.scaleDenominator = undefined;
            }
            if (_this.props.onRuleChange) {
                _this.props.onRuleChange(rule, _this.state.rule);
            }
            _this.setState({ rule: rule, scaleFieldChecked: checked });
        };
        _this.onFilterCheckChange = function (e) {
            var checked = e.target.checked;
            var rule = _cloneDeep(_this.state.rule);
            if (checked) {
                rule.filter = _this.state.storedFilter;
            }
            else {
                _this.setState({
                    storedFilter: rule.filter
                });
                rule.filter = undefined;
            }
            if (_this.props.onRuleChange) {
                _this.props.onRuleChange(rule, _this.state.rule);
            }
            _this.setState({ rule: rule, filterFieldChecked: checked });
        };
        _this.onRendererClick = function () {
            var editorVisible = _this.state.editorVisible;
            _this.setState({
                editorVisible: !editorVisible
            });
        };
        _this.onEditorWindowClose = function () {
            _this.setState({
                editorVisible: false
            });
        };
        _this.onRemoveButtonClick = function () {
            var onRemove = _this.props.onRemove;
            var rule = _this.state.rule;
            if (onRemove && rule) {
                onRemove(rule);
            }
        };
        _this.state = {
            editorVisible: false,
            rule: Rule.defaultProps.rule,
            symbolizerEditorVisible: false,
            storedFilter: ['=='],
            storedScaleDenominator: {}
        };
        return _this;
    }
    Rule.getDerivedStateFromProps = function (nextProps) {
        var rule = nextProps.rule || Rule.defaultProps.rule;
        return {
            rule: rule,
            filterFieldChecked: rule.filter ?
                true : false,
            scaleFieldChecked: rule.scaleDenominator ?
                true : false,
            symbolizerEditorVisible: false
        };
    };
    Rule.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var diffProps = !_isEqual(this.props, nextProps);
        var diffState = !_isEqual(this.state, nextState);
        return diffProps || diffState;
    };
    Rule.prototype.render = function () {
        var _a = this.props, internalDataDef = _a.internalDataDef, rendererType = _a.rendererType, oLRendererProps = _a.oLRendererProps, sldRendererProps = _a.sldRendererProps, locale = _a.locale, iconLibraries = _a.iconLibraries, colorRamps = _a.colorRamps;
        var _b = this.state, editorVisible = _b.editorVisible, rule = _b.rule, scaleFieldChecked = _b.scaleFieldChecked, filterFieldChecked = _b.filterFieldChecked;
        var featureRenderer;
        if (rendererType === 'SLD') {
            featureRenderer = React.createElement(SLDRenderer_1.SLDRenderer, __assign({ symbolizers: rule.symbolizers, onClick: this.onRendererClick }, sldRendererProps));
        }
        else {
            featureRenderer = React.createElement(Renderer_1.default, __assign({ symbolizers: rule.symbolizers, onClick: this.onRendererClick }, oLRendererProps));
        }
        // cast the current filter object to pass over to ComparisonFilterUi
        var cmpFilter = rule.filter;
        // cast to GeoStyler compliant data model
        var gsData = internalDataDef;
        return (React.createElement("div", { className: "gs-rule" },
            React.createElement("div", { className: "gs-rule-fields" },
                React.createElement("div", { className: "gs-rule-left-fields" },
                    locale.nameFieldLabel,
                    React.createElement(NameField_1.default, __assign({ value: rule.name, onChange: this.onNameChange, placeholder: locale.nameFieldPlaceholder }, this.props.ruleNameProps)),
                    featureRenderer,
                    !editorVisible ? null :
                        React.createElement(SymbolizerEditorWindow_1.default, { onClose: this.onEditorWindowClose, symbolizers: rule.symbolizers, onSymbolizersChange: this.onSymbolizersChange, iconLibraries: iconLibraries, colorRamps: colorRamps })),
                React.createElement("div", { className: "gs-rule-right-fields" },
                    React.createElement(FieldSet_1.default, { title: locale.scaleFieldTitle, onCheckChange: this.onScaleCheckChange, checked: scaleFieldChecked },
                        React.createElement(ScaleDenominator_1.default, { scaleDenominator: rule.scaleDenominator, onChange: this.onScaleDenominatorChange })),
                    React.createElement(FieldSet_1.default, { title: locale.filterFieldTitle, onCheckChange: this.onFilterCheckChange, checked: filterFieldChecked },
                        React.createElement(FilterTree_1.default, { internalDataDef: gsData, filter: cmpFilter, onFilterChange: this.onFilterChange })))),
            React.createElement(antd_1.Button, { className: "gs-rule-remove-button", style: {}, type: "danger", icon: "close-circle-o", size: "large", onClick: this.onRemoveButtonClick }, locale.removeRuleBtnText)));
    };
    Rule.componentName = 'Rule';
    Rule.defaultProps = {
        locale: en_US_1.default.GsRule,
        rule: {
            name: 'My Style',
            symbolizers: [{
                    kind: 'Mark',
                    wellKnownName: 'Circle'
                }]
        },
        dataProjection: 'EPSG:4326',
        rendererType: 'OpenLayers'
    };
    return Rule;
}(React.Component));
exports.Rule = Rule;
exports.default = LocaleWrapper_1.localize(Rule, Rule.componentName);
//# sourceMappingURL=Rule.js.map